/** The type of chambers that are available to the Committee route. */
export enum Chambers {
  House = 'house',
  Senate = 'senate',
  Joint = 'joint'
}
